import { Component, Inject, ViewChild, ElementRef } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { TranslatorService } from '../../../services/translator_service';
import { ResponsiveService } from '../../../services/responsive.service';
import { ApiQuery } from '../../../web-services/api/api.query';
import { ApiStore } from '../../../web-services/api/api.store';
import moment from 'moment';
import { combineLatest } from 'rxjs';
import _ from 'lodash';
import { TranslateModule } from '@ngx-translate/core';
import { RTLDivDirectiveDirective } from '../../../directives/rtldiv-directive.directive';
import { CommonModule } from '@angular/common';
import { WorkplansPopupApprovalComponent } from '../workplans-popup-approval/workplans-popup-approval.component';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatOption, MatSelectModule } from '@angular/material/select';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { MatCardModule } from '@angular/material/card';
import { DatepickerCustomComponent } from '../../../widgets/datepicker-custom/datepicker-custom.component';
import { MatSnackBar } from '@angular/material/snack-bar';
import { SnackbarComponent } from '../../snackbar/snackbar.component';
import { MatCheckboxModule } from '@angular/material/checkbox';

@Component({
  selector: 'app-create-new-workplan-modal',
  host: {
		'(document:click)': 'handleClick($event)',
	},
  standalone: true,
  imports: [TranslateModule, RTLDivDirectiveDirective,CommonModule,WorkplansPopupApprovalComponent,MatInputModule,
    MatFormFieldModule,MatSelectModule,NgbModule,FormsModule,MatCardModule,DatepickerCustomComponent,ReactiveFormsModule,
	MatCheckboxModule],
  templateUrl: './create-new-workplan-modal.component.html',
  styleUrl: './create-new-workplan-modal.component.scss'
})
export class CreateNewWorkplanModalComponent {
	@ViewChild('siteMatSelect',{static: false}) siteMatSelect;
	@ViewChild('truckMatSelect',{static: false}) truckMatSelect;
	@ViewChild('datepickerWrapper',{static: false}) datepickerWrapper: ElementRef;
	allTruckSelected : boolean = false;
	allSiteSelected : boolean = false;
	closeHour: boolean;
	closeMinute: boolean;
	clickMinuteCounter: any;
	trucksErrorFlag: boolean;
	missingSiteSelection: boolean;
	missingTruckSelection: boolean;
	isTruckListShowAll: boolean;
	sitesErrorFlag: boolean;
	selectedTrucks: any[] = [];
	clickHourCounter: number;
	closeTimer: boolean;
	selectedSites: any[] = [];
	selectedhours: any[];
	sitesListData: any[];
	sitesListDataBackup: any[];
	exist:boolean = false;
	showWorkplanPopupApproval: Boolean = false;
	showHideDropdownLists: any = {
		subSites: false,
		trucks: false,
		timeHour: false,
		timeMinute: false,
		collectionMethod: false
	};

	selectedWorkplanTime = {
		hour: '08',
		minute: '00'
	};

	workplanTime = {
		hours: [],
		minutes: []
	};

	showTimeErrorText: Boolean = false;
	trucksListData: any[];
	trucksListDataToShow: any[] = [];
	currentLang;
	translationsObj;
	showDatePicker: Boolean = false;
	selectedDates: any = {
		date: '',
		dateformat: ''
	};
	dateLbl:any = '';
	is_view_unexecuted_work_plans:any = 0;
	usageType = 1;
	isMobile: Boolean;

	constructor(private translator: TranslatorService,private apiQuery:ApiQuery,@Inject(MAT_DIALOG_DATA) public data: any,
	private responsiveService: ResponsiveService,private dialogRef: MatDialogRef<CreateNewWorkplanModalComponent>,
	private snackBar: MatSnackBar) {
		this.dialogRef.disableClose = true;
	}

	ngOnInit() {
		this.onResize();
		this.responsiveService.checkWidth();
		this.apiQuery.user$.subscribe(user => {
			if (!user) return;

			if(user["usage_type_id"] != 1){
				this.usageType = user["usage_type_id"];
			}
			this.is_view_unexecuted_work_plans = user["is_view_unexecuted_work_plans"];			
		});

		this.buildWorkplanTime();
		this.clickHourCounter = 0;
		this.clickMinuteCounter = 0;
		this.resetSelectedTime();
	}

	ngAfterViewInit() {	
		this.translator.currentLangEmitter$
		.subscribe(async value=>{						
			this.translationsObj = await this.translator.getTranslation(value).toPromise()			 
			this.currentLang = value;
			setTimeout(() => {
				combineLatest([
					this.apiQuery.filteredTrucks$,
					this.apiQuery.sitesListData$
				  ])
				  .pipe()
				  .subscribe(([trucksList,sitesList])=>{	
					if (trucksList == null || trucksList.length == 0) return;
					if (sitesList == null || sitesList.length == 0) return;
					this.selectedTrucks = [];
					this.selectedSites = [];	
					this.truckMatSelect.disabled = true;
					this.subscribeTrucksList(trucksList);
					this.subscribeSitesList(sitesList);		
				});
					
				this.dateLbl = this.translationsObj.WORKPLAN.TODAY;				
				if(this.data.dayClicked == undefined){
					return;
				}
				else{
					if(new Date(moment().format("YYYY-MM-DD 00:00:00")).getTime() != new Date(this.data.dayClicked).getTime()){
						this.selectedDates.date = moment(this.data.dayClicked).format('DD/MM/YYYY');
						this.selectedDates.dateformat = moment(this.data.dayClicked).format('YYYY-MM-DD');	
						this.dateLbl = this.selectedDates.date;				
					}else{
						this.dateLbl = this.translationsObj.WORKPLAN.TODAY;				
					}
				}
			}, 0);
		});
	}

	onResize() {
		this.responsiveService.getMobileStatus().subscribe(isMobile => {
		  this.isMobile = isMobile;
		});
	}

	showHideDatePicker = () => {
		this.showDatePicker = !this.showDatePicker;
		if(this.showDatePicker){
			if(this.currentLang == 'iw'){
				const right_chv = document.querySelector('.ngb-dp-arrow-prev');
				const right_btn = right_chv.querySelector('button');
				const right_span = right_btn.querySelector('span');
				right_span.style.transform = 'rotate(45deg)';

				const left_chv = document.querySelector('.ngb-dp-arrow-next');
				const left_btn = left_chv.querySelector('button');
				const left_span = left_btn.querySelector('span');
				left_span.style.transform = 'rotate(-135deg)';
			}
		}
	}

	onSelectDates = (selectDates: any) => {
		this.selectedDates.date = selectDates.date;
		this.selectedDates.dateformat = selectDates.dateformat;	
		setTimeout(() => {
			this.dateLbl = this.selectedDates.date;	
		}, 0);
		this.buildWorkplanTime();
	}

	subscribeTrucksList = (trucksList) => {
		this.trucksListData = trucksList;
		this.trucksListDataToShow = trucksList;
	}

	resetSelectedTime = () => {
		const timeNowHour = moment().add(1, 'hours').format('HH');
		this.selectedWorkplanTime = {
			hour: timeNowHour,
			minute: '00'
		};
	}

	subscribeSitesList = (sitesList: any[]) => {
		this.sitesListDataBackup = sitesList;
		this.sitesListData = sitesList;
		if(this.sitesListData.length == 1){
			this.chooseSite(this.sitesListData);
		}
	}

	closeModal = () => {
		if (this.showWorkplanPopupApproval) {
			this.showWorkplanPopupApproval = false;
			return;
		}
		this.resetSelectedTime();
		this.openDropDownList('');
		this.dialogRef.close();
		this.sitesErrorFlag = false;
		this.trucksErrorFlag = false;
		this.showTimeErrorText = false;
	}

	openDropDownList = (list_name: string) => {
		_.each(this.showHideDropdownLists, (value, key) => {
			if (key === list_name) {
				this.showHideDropdownLists[list_name] = !value;
			} else {
				this.showHideDropdownLists[key] = false;
			}
		});
	}

	buildWorkplanTime = () => {
		this.workplanTime.hours = [];
		this.workplanTime.minutes = [];
		if(new Date(moment().format("YYYY-MM-DD 00:00:00")).getTime() == new Date(moment(this.selectedDates.dateformat).format("YYYY-MM-DD 00:00:00")).getTime()){			
			const timeNowHour = parseInt(moment().add(1, 'hours').format('HH'));
			for (let i = 0; i <= 59; i++) {
				if ((i >= 0 && i <= 9) && (i >= timeNowHour)) {
					this.workplanTime.hours.push(`0${i}`);
					this.workplanTime.minutes.push(`0${i}`);
				} else {
					if (i < 24 && i >= timeNowHour) {
						this.workplanTime.hours.push(`${i}`);
					}else{
						if ((i >= 0 && i <= 9)){
							this.workplanTime.minutes.push(`0${i}`);
						}else{
							this.workplanTime.minutes.push(`${i}`);
						}
					}
				}
			}
		}else{			
			for (let i = 0; i <= 59; i++) {
				if ((i >= 0 && i <= 9)) {
					this.workplanTime.hours.push(`0${i}`);
					this.workplanTime.minutes.push(`0${i}`);
				} else {
					if (i < 24) {
						this.workplanTime.hours.push(`${i}`);
					}
					this.workplanTime.minutes.push(`${i}`);
				}
			}
		}
		if(this.workplanTime != null){
			this.selectWorkplanTime(this.workplanTime.hours[0],"hour");
			this.selectWorkplanTime(this.workplanTime.minutes[0],"minute");
		}
	}

	selectWorkplanTime = (time, type) => {
		this.showTimeErrorText = false;
		this.selectedWorkplanTime[type] = time;
	}

	isStartTimeValid = () => {
		const timeNowHour = moment().format('HH');
		return this.selectedWorkplanTime.hour >= timeNowHour;
	}

	openSnackbar(): void {
		this.snackBar.openFromComponent(SnackbarComponent,
		  {
			data: { popup: 'createWorkplan', selectedWorkplanTime: this.selectedWorkplanTime, 
				selectedSites: this.selectedSites, selectedDates: this.selectedDates, selectedTrucks: this.selectedTrucks,
				is_view_unexecuted_work_plans: this.is_view_unexecuted_work_plans },
			panelClass: 'custom-snackbar-class'
		  }		
		);	
	}

	saveWorkplan = () => {
		if (this.selectedSites.length == 0) {
			this.sitesErrorFlag = true;
			if(!this.trucksErrorFlag){
				this.missingSiteSelection = true; 
			}
		}
		else {
			this.sitesErrorFlag = false;
			this.missingSiteSelection = false;
		}
		if(this.dateLbl == this.translationsObj.WORKPLAN.TODAY){
			if (this.selectedTrucks.length == 0 && this.selectedSites.length != 0) {
				this.trucksErrorFlag = true;
			}
			else {
				this.trucksErrorFlag = false;
			}
		}
		if(this.sitesErrorFlag || this.trucksErrorFlag){
			return;
		}
		if(new Date(moment().format("YYYY-MM-DD 00:00:00")).getTime() == new Date(moment(this.selectedDates.dateformat).format("YYYY-MM-DD 00:00:00")).getTime()){
			if (!this.isStartTimeValid()) {
				this.showTimeErrorText = true;
				return;
			}
		}
		if (!this.sitesErrorFlag && !this.trucksErrorFlag && this.dateLbl == this.translationsObj.WORKPLAN.TODAY) {
			this.showWorkplanPopupApproval = true;
		}else{
			this.approveCancelWorkplanChanges(true);
		}
	}

	approveCancelWorkplanChanges = (ans: boolean) => {
		this.showWorkplanPopupApproval = false;

		if (!ans) {
			return;
		}

		this.openSnackbar();
		this.closeModal();
	}

	updateTruckListPerSiteSelection() {
		this.trucksListDataToShow = [];
		this.selectedSites.forEach((element) => {
			this.trucksListDataToShow = [...this.trucksListDataToShow, ..._.filter(this.trucksListData, (truck) => {
				return truck.site_id === element.site_id;
			})];			
		});
		this.updateTruckFlag(this.trucksListDataToShow);
	}

	updateTruckFlag(data) {
		this.allTruckSelected = false;
		this.selectedTrucks = [];
		this.truckMatSelect.disabled = false;
		if(data.length == 1){
			this.selectedTrucks.push(data[0]);
			this.truckMatSelect.disabled = true;
		}
	}

	private isClickInsideElement(clickedElement: Element, targetElement: ElementRef): boolean {
		if (!targetElement || !targetElement.nativeElement) {
			return false;
		}
		return targetElement.nativeElement.contains(clickedElement);
	}

	handleClick(event) {
		let clickedComponent = event.target;
		let insideHour = false;
		let insideMinute = false;
		let insideSelectedDates = false;
		
		do {
			if (clickedComponent.className === "time-btn left") {
				insideHour = true;
				this.clickHourCounter++;
				break;
			}
			if (clickedComponent.className === "time-btn right") {
				insideMinute = true;
				this.clickMinuteCounter++;
				break;
			}
			// Check if click is inside the selected-dates field
			if (clickedComponent.className === "selected-dates" || 
				clickedComponent.classList && clickedComponent.classList.contains('selected-dates')) {
				insideSelectedDates = true;
				break;
			}
			if (clickedComponent.className === "")
				break;
			clickedComponent = clickedComponent.parentNode;
		} while (clickedComponent);

		if (insideHour) {
			this.closeMinute = true;
			this.closeHour = false;
			this.openDropDownList('timeHour');
		}
		if (insideMinute) {
			this.closeHour = true;
			this.closeMinute = false;
			this.openDropDownList('timeMinute');
		}
		if (!insideMinute && !insideHour) {
			this.closeHour = true;
			this.closeMinute = true;
		}
		
		// Handle datepicker clicks
		if (insideSelectedDates) {
			// Click on the date field - toggle the datepicker
			this.showHideDatePicker();
		} else if (this.showDatePicker && !this.isClickInsideElement(event.target, this.datepickerWrapper)) {
			// Click outside the datepicker - close it
			this.showDatePicker = false;
		}
	}

	toggleAllTruckSelection() {
		if (this.allTruckSelected) {
		  this.truckMatSelect.options.forEach((item: MatOption) => item.select());
		} else {
		  this.truckMatSelect.options.forEach((item: MatOption) => item.deselect());
		}
	}

	toggleAllSiteSelection() {
		if (this.allSiteSelected) {
			this.siteMatSelect.options.forEach((item: MatOption) => item.select());
		} else {
			this.siteMatSelect.options.forEach((item: MatOption) => item.deselect());
		}
	}
	
	chooseSite(value){
		this.selectedSites = value;
		let newStatus = true;
		this.siteMatSelect.options.forEach((item: MatOption) => {
			if (!item.selected) {
				newStatus = false;
			}
		});
		this.allSiteSelected = newStatus;
		this.sitesErrorFlag = false;
		this.missingSiteSelection = false;
		this.updateTruckListPerSiteSelection();
	}

	truckOptionClick() {
		let newStatus = true;
		this.truckMatSelect.options.forEach((item: MatOption) => {
			if (!item.selected) {
				newStatus = false;
			}
		});
		this.allTruckSelected = newStatus;
	}

	searchSites(value: any) {  
		let filter = value['value'].toLowerCase();
		this.sitesListData = this.sitesListDataBackup.filter(site => site.site_name.toLowerCase().includes(filter));
	}

	searchTrucks(value: any) { 
		let filter = value['value'].toLowerCase();
		this.trucksListDataToShow = this.trucksListData.filter(truck => truck.tablet_id.toString().toLowerCase().includes(filter));
	}
}
